import axiosGlobalInstance from './configHttpInstance/http-instance';
import mockUserList from './fakes/user-listing';

const getUserFile = (params) => {
  const useFake = !!Number(process.env.REACT_APP_MOCK_API);

  if(useFake) {
    return new Promise((resolve) => {
      setTimeout(() => resolve(mockUserList), 3000);
    });
  }

  const { migrationId } = params;
  const httpInstance = axiosGlobalInstance();

  return httpInstance({
    method: 'GET',
    url: `/migrations/${migrationId}/users/download`,
    responseType: 'blob',
  });
}

export default getUserFile;

